import React from 'react';
import { Delayed } from './Delayed';
import { useFakeLoader } from './hooks';
import { LoadingOverlay } from './LoadingOverlay';

// The idea behind this component is to delay showing the LoadingOverlay for a (ideally not noticeable) while in case the dependency loads within that delay
// This should reduce the number of times the LoadingOverlay shows for a split seconds before disappearing causing a blip on the screen.
// If the waiting time is reach the component also ensures that the LoadingOverlay shows for a minimum amount of time before disappearing.
// This is again to reduce the blip effect caused by loading screen showing and disappearing for a split second.
export const BetterLoadingOverlay = ({
  debugString,
  color,
  shadeBackground,
  isPending,
}: {
  debugString: string;
  color?: 'primary' | 'secondary';
  shadeBackground?: boolean;
  isPending: boolean;
}) => {
  return (
    <BetterLoading
      debugString={debugString}
      isPending={isPending}
      fallback={
        <LoadingOverlay color={color} shadeBackground={shadeBackground} />
      }
    />
  );
};

export const BetterLoading = ({
  children = null,
  debugString,
  fallback,
  isPending,
  wait = 250,
  freez = 200,
}: {
  children?: JSX.Element | null;
  debugString: string;
  fallback: JSX.Element;
  isPending: boolean;
  wait?: number;
  freez?: number;
}) => {
  const { fakeLoading, startFakeLoading } = useFakeLoader(freez);

  if (isPending || fakeLoading) {
    console.debug('BetterLoading showing fallback', debugString);
    return (
      <Delayed delay={wait} onDelayEnd={startFakeLoading}>
        {fallback}
      </Delayed>
    );
  } else {
    return children;
  }
};
